import { render, staticRenderFns } from "./StepInputDataV2.vue?vue&type=template&id=5a544b4c&scoped=true"
import script from "./StepInputDataV2.vue?vue&type=script&lang=js"
export * from "./StepInputDataV2.vue?vue&type=script&lang=js"
import style0 from "./StepInputDataV2.vue?vue&type=style&index=0&id=5a544b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a544b4c",
  null
  
)

export default component.exports